export function* Range(n1: number, n2?: number, step = 1) {
  if (n2 === undefined) {
    // If only one parameter is provided, generate range from 0 to n1-1
    for (let i = 0; i < n1; i += step) {
      yield i
    }
  } else {
    // With start and end, generate inclusive range from n1 to n2
    if (step > 0) {
      for (let i = n1; i <= n2; i += step) {
        yield i
      }
    } else {
      for (let i = n1; i >= n2; i += step) {
        yield i
      }
    }
  }
}
